import React from 'react';
import {Link, Typography} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import LegalContentWrapper from './LegalContentWrapper.js';
import LegalSection from './LegalSection.js';

const Accessibility = ()=><LegalContentWrapper title="הצהרת נגישות" lastUpdated="08.08.2025">
  <LegalSection title="1. הקדמה">
    <Typography>
      האתר simonacherry.com רואה חשיבות רבה בהנגשתו לאנשים עם מוגבלות, כדי לאפשר לכלל הגולשים לגלוש באתר, לעיין במידע, ולהשתמש בשירותים המוצעים בו, באותה רמת יעילות והנאה כמו כל משתמש אחר.<br/>
      ההנגשה באתר מבוצעת בהתאם להוראות תקנות שוויון זכויות לאנשים עם מוגבלות והתקן הישראלי 5568 - נגישות אתרי אינטרנט, ברמה AA ככל הניתן.
    </Typography>
  </LegalSection>
  <LegalSection title="2. טכנולוגיית הנגישות באתר">
    <Typography>
      ההתאמות באתר מבוצעות באמצעות תוסף הנגישות של <Link href="https://accessibility-widget.pages.dev/" target="_blank" rel="noopener">Sienna</Link>, המסייע בהנגשת האתר לבעלי מוגבלויות ומאפשר:<br/>
      <ul>
        <li>שינוי גודל טקסט.</li>
        <li>שינוי ניגודיות צבעים.</li>
        <li>הדגשת קישורים.</li>
        <li>ניווט באמצעות מקלדת.</li>
        <li>התאמת צבעי טקסט ורקע לצרכי המשתמש.</li>
        <li>תיאורי טקסט חלופיים (Alt Text) לתמונות במקומות הרלוונטיים.</li>
        <li>האתר מותאם לגלישה בדפדפנים מודרניים (מומלץ Google Chrome) ולמכשירים ניידים.</li>
      </ul>
    </Typography>
  </LegalSection>
  <LegalSection title="3. הפעלת הנגישות">
    <Typography>
      להפעלת תפריט הנגישות, יש ללחוץ על אייקון הנגישות הממוקם בצד השמאלי התחתון של המסך, ולבחור את ההתאמות הרצויות לשיפור חוויית הגלישה.
    </Typography>
  </LegalSection>
  <LegalSection title="4. מגבלות נגישות">
    <Typography>
      אנו משקיעים מאמצים רבים להנגיש את כלל עמודי האתר. עם זאת, ייתכן שחלק מהתכנים או הפונקציות עדיין אינם נגישים במלואם.<br/>
      אנו פועלים לשפר זאת באופן מתמיד.
    </Typography>
  </LegalSection>
  <LegalSection title="5. פניות בנושא נגישות">
    <Typography>
      במידה ונתקלתם בבעיית נגישות, או שיש לכם הצעה לשיפור, נשמח שתפנו אלינו.<br/>
      הדרך המהירה ביותר ליצור קשר היא באמצעות המייל: <Link href="mailto:simona@simonacherry.com">simona@simonacherry.com</Link> או בעמוד <Link href="/contact">"צור קשר"</Link> באתר.<br/>
      אנחנו מתחייבים לבדוק את הפניה ולעשות מאמץ ראוי לפתרון הבעיה בהקדם.
    </Typography>
  </LegalSection>
  <LegalSection title="6. עדכון ההצהרה">
    <Typography>
      הצהרה זו עשויה להתעדכן מעת לעת, בהתאם לשינויים טכנולוגיים או לדרישות החוק.<br/>
      תאריך העדכון האחרון מופיע בראש העמוד.
    </Typography>
  </LegalSection>
</LegalContentWrapper>;

export default withMainContainer(withTitle('הצהרת נגישות', Accessibility));
